import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedMaterialModule } from 'src/app/modules/shared-material/shared-material.module';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { SharedComponentsModule } from 'src/app/modules/shared-components/shared-components.module';
import { SharedServicesModule } from 'src/app/modules/shared-services/shared-services.module';
import { TournamnentIngameInfoComponent } from '../games/tournamnent-ingame-info/tournamnent-ingame-info.component';
import { SwiperModule } from 'swiper/angular';
import { RouterModule } from '@angular/router';
import { REACTIVATION_MODULE_NOT_TRANSLATED } from './reactivation.routing.module';
import { ReactivationInfoComponent } from './reactivation-info/reactivation-info.component';
import { ReactivationCategoryComponent } from './reactivation-category/reactivation-category.component';
import { MainReactivationComponent } from './main-reactivation/main-reactivation.component';


@NgModule({
  declarations: [
    ReactivationCategoryComponent,
    MainReactivationComponent,
  ],
  imports: [
    RouterModule.forChild(REACTIVATION_MODULE_NOT_TRANSLATED),
    CommonModule,
    SharedMaterialModule,
    SharedServicesModule,
    SharedComponentsModule,
    FlexLayoutModule,
    SwiperModule
  ],
  exports: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReactivationModule {
}
